var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCordialMenuIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L24 0 24 24 0 24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#179C8F",
    fillRule: "nonzero",
    d: "M4.66 9.438h14.648c-.517-2.099-1.522-4.526-2.838-7.16H7.498c-1.317 2.634-2.322 5.06-2.839 7.16m16.207 4.142c-.523 3.136-2.962 5.005-8.244 4.992V22.2h5.148v1.276H6.197V22.2h5.148v-3.629c-5.282.013-7.721-1.855-8.244-4.991C2.46 9.735 5.016 4.354 6.715 1h10.536c1.701 3.35 4.256 8.737 3.615 12.58z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCordialMenuIcon);
export default __webpack_public_path__ + "static/media/cordial-menu-icon.c689f959.svg";
export { ForwardRef as ReactComponent };